module.exports = __webpack_public_path__ + "img/cross.3741a2c6.svg";